<template>
<div class="" style="">

   <div class="row  yo-text-normal "  >
      <div class="col s12 yo-bg-color-tertiary">
        <div class="row" style="border:2px solid #fff;padding:20px 20px;">




            
            <div class="row" v-if="idIscrizione<1">
              <div class="col s12 " style="padding-bottom:10px;"><h3 class="yo-align-center yo-bold" style="margin:0;">

                Webinar 4<sup>th</sup> June (only for registered attendees)
<br /><br />
Would you like to see it again?
<br /><br />
Please insert your Email and Password


                </h3></div>
              <div class="col s12 m6 offset-m3"><el-input class="no-border" placeholder="Email" v-model.trim="form.email" auto-complete="off"></el-input></div>
              <div class="col s12 m6 offset-m3" style="padding-top:20px;padding-bottom:20px;"><el-input class="no-border" placeholder="Password" type="password" v-model.trim="form.password" auto-complete="off"  ></el-input></div>
            
              <div class="col s12 m6 offset-m3 yo-align-center yo-pointer yo-valign-text-center  yo-text-bold" v-on:click="goLogin" style="background:#FDE1AE;height:42px;">LOGIN TO WEBINAR</div>
            </div>

            <div class="row" v-else>
               <div class="col s12 yo-align-center">
                 <h3 class="yo-align-center">It is absolutely forbidden to download and distribute the video.</h3>
               <!--
                 <img src="https://myquadra.it/swrapper/img/loc.jpg" style="width:100%;padding:32px;"/>
              -->
               
               <video style="width:100%;padding:32px;" controls>
  <source src="https://docs.biomedia.net/temp/WEBINAR_WISC/WISC2020_360p.mp4" type="video/mp4">

  Your browser does not support the video tag.
</video>

               </div>
            </div>




        </div>
      </div>
   </div>


   

</div>
</template>

<script>
import emailRecovery from './Email-recovery.vue'

export default {
   name: 'home',
   components: {

   },
   created () {
      let id = sessionStorage.getItem('idiscrizione')
      if(id>0){
         this.idIscrizione = id
      }else{
         this.idIscrizione = -1
      }
   },
   data() {
    return {
      form: {
        email: '',
        password: ''
      },
      idIscrizione:-1,
      rules: {
        uname: [
          { required: true, message: 'La email è obbligatoria', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'La password è obbligatoria', trigger: 'blur' }
        ]        
      }
    };
  },
  methods: {

    goLogin(event) {
      var errors = []

      if(this.form.email=='')
        errors.push('Email is mandatory')
      if(this.form.password=='')
        errors.push('Password is mandatory')

              
      if(errors.length>0){
        this.$alert(errors.join('<br />'),'LOGIN ERROR',{type: 'error',dangerouslyUseHTMLString: true})
      }else{

      /* ALcuni utenti aventi diritto
      
         mariesoleilmasse@icloud.com
         9vpgnjsk
         
         bskped@hanmail.net
         kae98ybw

      */
        this.axios.query('fetchRow',`SELECT iscrizione.id AS id,contatto.id AS contatto,cognome,contatto.nome,contatto.email,password,carrello.articolo 
        FROM iscrizione LEFT JOIN contatto on contatto.id=iscrizione.contatto 
        LEFT JOIN carrello ON carrello.iscrizione=iscrizione.id 
        WHERE iscrizione.evento=2797 AND iscrizione.stato=10 AND FIND_IN_SET(carrello.articolo,'2954,2955,2956,2974') AND contatto.email = →email AND password= →password`,this.form).then((data) => {
          console.log("LOGIN CHECK")
          console.log(data)
          if(data.result.id > 0 && data.result.email==this.form.email){
             /*
              this.$teras.utente = data.result
              this.$teras.event.emit('afterlogin')
              this.$teras.save("utente",this.$teras.utente)
              this.$teras.app.auth = true
              this.$router.push('/mylogin-home')
              */
             sessionStorage.setItem('idiscrizione', data.result.id)
             this.idIscrizione = sessionStorage.getItem('idiscrizione')
             console.log("funziona")
          }else{
            this.$alert('Email o password errate!','LOGIN ERROR',{type: 'error',dangerouslyUseHTMLString: true})
          }
        })

      }
    },
    goLogsssin() {
      console.log(this.$teras)
      this.axios.query('fetchRow','SELECT DISTINCT ana.id AS id, ana.cognome, ana.nome, ana.password, ana.email, codicefiscale FROM bm_bvent.contatto AS ana WHERE ana.email = →email AND ana.password = →password ORDER BY ana.cognome,ana.nome',this.form).then((data) => {
        console.log("LOGIN CHECK")
        console.log(this.$teras.utente)
        console.log(data)
        if(data.result.id > 0){
            this.$teras.utente = data.result
            this.$teras.step = -1
            this.$teras.event.emit('afterlogin')
            this.$teras.save("utente",this.$teras.utente)
            this.$teras.app.auth = true
            this.$router.push('/home')
        }else{
          this.$notify.error({title: 'Errore',message: "ERRORE DI AUTENTICAZIONE"});
        }
      })
    }
  }
}
</script>


<style>
.arrow-right {
  width: 0; 
  height: 0; 
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  float:left;
  border-left: 14px solid white;

  margin-top:6px;
}
.catalogo-fad .header{
   background-image:url('../assets/catalogo-fad.png');
}
.fad-evidenza{
   padding-top:10px;
   height:170px;overflow:hidden;
}
.fad-evidenza:first-child{
   padding-top:20px;
   height:180px;overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Wisc-webinar.vue